// extracted by mini-css-extract-plugin
export var border = "_10-8";
export var brand = "_10-t";
export var button = "_10-l";
export var center = "_10-a";
export var centered = "_10-6";
export var closeButton = "_10-c";
export var disabledWrapper = "_10-m";
export var error = "_10-p";
export var extraLarge = "_10-4";
export var extraSmall = "_10-1";
export var fill = "_10-i";
export var footer = "_10-h";
export var footerAction = "_10-j";
export var footerButtons = "_10-k";
export var header = "_10-7";
export var headerWithClose = "_10-d";
export var icon = "_10-o";
export var info = "_10-s";
export var inline = "_10-9";
export var large = "_10-3";
export var main = "_10-e";
export var modal = "_10-0";
export var nearFull = "_10-5";
export var neutral = "_10-u";
export var noPadding = "_10-g";
export var none = "_10-v";
export var scrollable = "_10-f";
export var small = "_10-2";
export var success = "_10-r";
export var tight = "_10-n";
export var titleIcon = "_10-b";
export var warn = "_10-q";